/**
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { ModelReference } from 'genkit';
import type { CommonPluginOptions } from '../../common/types.js';

/**
 * Evaluation metric config. Use `metricSpec` to define the behavior of the metric.
 * The value of `metricSpec` will be included in the request to the API. See the API documentation
 * for details on the possible values of `metricSpec` for each metric.
 * https://cloud.google.com/vertex-ai/generative-ai/docs/model-reference/evaluation#parameter-list
 */

/**
 * Options specific to Model Garden configuration
 * @deprecated
 * */
export interface ModelGardenOptions {
  models: ModelReference<any>[];
  openAiBaseUrlTemplate?: string;
}

/** @deprecated */
export interface PluginOptions
  extends CommonPluginOptions,
    ModelGardenOptions {}
